// @flow
import BaseComponent from '../base_component/base_component'

export default class GridViewPage extends BaseComponent {

    initialize() {
        this.isGridView = false;
        this.cold = true;
        this.previousData = null;
        if (typeof(Storage) !== "undefined") {
            this.pricingData = JSON.parse(window.localStorage.getItem('pricingData')) || {}
        } else {
            this.pricingData = {}; // TODO: LocalStorage
        }
    }

    functions() {
        return {
            toggle: (type: string) => type == 'GridView' ? this.toggleGridView() : null,
            dataTableModified: () => this.isGridView ? this._refreshData() : null
        }
    }

    toggleGridView() {
        this.isGridView = !this.isGridView;
        this.find('.table-view').toggle(!this.isGridView);
        let gridView = this.find('.grid-view');
        gridView.toggle(this.isGridView);

        if (this.isGridView && this.cold) {
            this._refreshData();
        }
    }

    _refreshData() {
        let gridView = $('.grid-view');
        let templateHTML = gridView.find('.template')[0].outerHTML;
        let rows = this.find('.dataTables_wrapper .dataTables_scrollBody table.dataTable')
        .DataTable().rows({ filter : 'applied'}).data().toArray();
        if (this.previousData == rows.toString()) {
            return this.previousData = rows.toString();
        }
        
        gridView.find('.grid-item:not(.template)').remove();
        this.previousData = rows.toString();
        rows.forEach(([
                    star, img, company, __, date, content_icon, ticker, title, summary
                ]) => {
            let newHTML: any = new String(templateHTML);
            newHTML = newHTML.replace('[[COMPANY]]',
                company.match('company_name">\\s*([^\\n]*)')[1].trim() + '\n' +
                star);
            newHTML = newHTML
                .replace('[[DATE]]', date || '')
                .replace('[[TICKER_NAME]]', (ticker || '').toLowerCase().replace(' ', '_'))
                .replace('[[TICKER]]', ticker || '')
                .replace('[[IMAGE]]', img)
                .replace(' template"', '"');

            let url = (content_icon || '').match(/href="([^"]*)"/);
            if (url) {
                newHTML = newHTML
                    .replace('[[URL]]', url[1])
                    .replace('[[TITLE]]', title || '')
                    .replace('[[BODY]]', summary || '')
            } else {
                newHTML = newHTML.replace('grid-item', 'grid-item no-doc')
            }
            
            this.cold = false;
            gridView.append(newHTML);
            if (ticker && ticker !== '' ) { this._getPricingData(ticker) }; // !== ''
        });
    }

    _getPricingData(ticker: string) {
        let outDatedTime = new Date();
        outDatedTime.setMinutes(outDatedTime.getMinutes() - 5);
        let checkedTime = this.pricingData[ticker] && this.pricingData[ticker].time;
        if (typeof(checkedTime) === 'string') checkedTime = new Date(Date.parse(checkedTime));

        if (!this.pricingData[ticker] || checkedTime < outDatedTime) {
            $.get(this._getPricingApi(ticker), result => {
                if (result['Error Message'] || !result['Global Quote']) {
                    this.pricingData[ticker] = {
                        result: result['Error Message'] || 'No result found.',
                        time: new Date()
                    }
                } else {
                    this.pricingData[ticker] = {
                        result: 'Success',
                        prev: result['Global Quote']['08. previous close'].match(/[0-9]*\.?[0-9]/)[0],
                        now: result['Global Quote']['05. price'].match(/[0-9]*\.?[0-9]/)[0],
                        change: parseFloat(result['Global Quote']['09. change']),
                        time: new Date()
                    }
                    if (typeof(Storage) !== "undefined") {
                        window.localStorage.setItem('pricingData', JSON.stringify(this.pricingData))
                    }
                };
                this._updateTicker(ticker);
            });
        } else {
            this._updateTicker(ticker);
        }
    }

    _getPricingApi(ticker: string) {
        return `https://www.alphavantage.co/query?function=GLOBAL_QUOTE` +
            `&symbol=${ticker}&apikey=${this.options.api_key}`;
    }

    _updateTicker(ticker: string) {
        let pricingData = this.pricingData[ticker];
        if (pricingData.result !== 'Success') return;

        let $element = this.find(`.${ticker.toLowerCase().replace(' ', '_')}-pricing`);
        $element.children().first().html(`<span class=visible-lg-blockx>Prev: </span>$${pricingData.prev}`);
        let $currentData = $element.children().last();

        $currentData.html(`<span class=visible-lg-blockx>Now: </span>$${pricingData.now}`);
        $currentData.toggleClass('up', pricingData.change > 0);
        $currentData.toggleClass('down', pricingData.change < 0);
    }
}